export default {
  default: () => import("/workspace/layouts/default.vue").then(m => m.default || m),
  events: () => import("/workspace/layouts/events.vue").then(m => m.default || m)
}